import { render } from "./CreateReturnBill.vue?vue&type=template&id=3f5089c4&scoped=true"
import script from "./CreateReturnBill.vue?vue&type=script&lang=js"
export * from "./CreateReturnBill.vue?vue&type=script&lang=js"

import "./CreateReturnBill.vue?vue&type=style&index=0&id=3f5089c4&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5089c4"]])

export default __exports__